const PUBLIC = process.env.PUBLIC_URL || "";
export const LOGO_FULL = `${PUBLIC}/veteo-logo.png`;
export const LOGO_WHITE = `${PUBLIC}/veteo-logo-white.png`;

export function Logo({ variant = "full", className = "h-9" }) {
  const src = variant === "dark" ? LOGO_WHITE : LOGO_FULL;
  return <img src={src} alt="Veteo" className={`${className} w-auto shrink-0 object-contain`} data-testid="veteo-logo" />;
}
